import Flag from '@atlaskit/flag';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import React from 'react';
// import ScreenEventAnalytics from '../../../../../common/analytics/components/screen-event-analytics';
// import { AnalyticsEventSource } from '../../../analytics/constants';
import { ChatRoomLink, ServiceDeskLink } from '../help-links';
import { ErrorTypeEnum, PanelTypeEnum } from '../constants';
import { ReportError } from '../error-reporting';
import '../shared.scss';
import './not-found.scss';

export const NotFound = (props: {
  title?: string;
  // Not found is used at many places where title is being passed, but it should not be honoured and added by mistake
  // so in order to add any custom title only title prop is not enough, mark the enableCustomTitle as true also
  // e.g. error-wrapper pass custom title, but it's not be used for Not found component
  enableCustomTitle?: boolean;
  error?: Error;
  description?: React.ReactNode;
  enableReporting?: boolean;
  enableTicketCreationOption?: boolean;
}) => {
  const {
    enableReporting = false,
    enableTicketCreationOption = false,
    title = 'Not Found',
    enableCustomTitle = false,
  } = props;
  return (
    <div className="not-found">
      {/* <ScreenEventAnalytics
            event={{
                name: AnalyticsEventSource.NOT_FOUND_SCREEN
            }}
        /> */}
      <div className="error-report-container">
        <Flag
          title={enableCustomTitle ? title : 'Not Found'}
          description={
            props.description ?? (
              <>
                <p>
                  We&apos;re having trouble finding the page you requested. Please consult the Advocate Central team via
                  the <ChatRoomLink /> or <ServiceDeskLink /> for assistance.
                </p>
                {props.error && (
                  <p>
                    <strong>Error:</strong> <code>{props.error.message}</code>
                  </p>
                )}
              </>
            )
          }
          appearance="normal"
          id="not-found-error"
          icon={<WarningIcon label="Not found" />}
        />
        {enableReporting && (
          <ReportError
            errorMessage={props.error ? props.error.message : 'We are having trouble finding the page you requested.'}
            type={PanelTypeEnum.ERROR_PANEL}
            enableTicketCreationOption={enableTicketCreationOption}
          />
        )}
      </div>
    </div>
  );
};
// this is used by error-wrapper for identifying the component
NotFound.displayName = ErrorTypeEnum.NOT_FOUND;
